<template>
    <div class="">


        <div class="nav">
            <div class="bk2">

            </div>

            <div class="tit">
                &nbsp;
                <div class="cn_tit">
                     {{ title }}
                </div>
               
                <div class="en_tit">
                    {{ en }}
                </div>

            </div>
            <!-- <div class="meun">...</div> -->
        </div>


    </div>
</template>


<script>
export default {
    data() {
        return {

        }
    },
    props: {
        title: {
            type: String,
            default: '乐行巴士'
        }, en: {
            type: String,
            default: ''
        },
        show_bk: {
            type: Boolean,
            default: true,
        },
        url: {
            type: String,
            default: '',
        }
    },
    methods: {
         
    }
}
</script>

<style  scoped>
 
.en_tit {
    position: absolute;
    left: 0;
    z-index: 1;
    top: 0;
    width: 100vw;
    text-align: center;
   

    background-image: linear-gradient(to bottom, #1873cb, #5BA9FA);
    -webkit-background-clip: text;
    background-clip: text;
    color: transparent;
    font-family: "v3ui"; 
    font-size: 50px;
    font-weight: 500;
    text-align: center;



}

.nav {
   
    width: 100vw;
    
   height: 100px;
  
    color: #313E4B;
   

}

.back {
    flex: 0 0 12%;
    
    background-repeat: no-repeat;
    background-size: 20% 100%;
    background-position: 6upx 0upx;
    color: #fff;
    padding-left: 10px;
}

.bk2 {
    flex: 0 0 12%;
}

.tit {
    
    position: relative;

}
.cn_tit {
    font-family: "v3ui";
    flex: 0 0 76%;
    font-size: 50px;
    font-weight: 500;
    text-align: center;
    color: #fff;
    position: relative;
    width: 100%;

    position: absolute;
    top: 20px;
    left: 0;
    z-index: 2;
}

.meun {
    text-align: right;
    flex: 0 0 12%;
}
</style>



// WEBPACK FOOTER //
// src/components/nav.vue